import { Component, OnDestroy, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TemplateService } from '@app/core/services/template.service';
import { CategoryTemplateList, TemplateCategory } from '@app/shared/models/distribution-doc-models';

@Component({
    templateUrl: './template-management.component.html',
    styleUrls: ['./template-management.component.scss']
})
export class TemplateManagementComponent extends BaseWithBundleComponent
                                         implements OnInit, OnDestroy {

    public templateCategories: CategoryTemplateList[];
    public selectedCategory: CategoryTemplateList;

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected templateService: TemplateService) {
        super(componentServiceBundle);
        this._idPrefix = 'template_management.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.templateService.getTemplateCategoryList([], true, false)
                            .subscribe((result: CategoryTemplateList[]) => {
            this.templateCategories = result;
            this.selectCategory(this.templateCategories.find((category) => {
                return category.template_category.key === TemplateCategory.SMP_MAINDOCUMENT;
            }));
        }, err => this.handleError(err));
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public selectCategory(category: CategoryTemplateList): void {
        this.selectedCategory = category;
    }

}
